import {API_URL} from "../../constants/ConfigFromBuildEnvironment";
import HTTPRequestExecuter from "./HTTPRequestExecuter";
import EventPublisher from "../../utils/EventPublisher";
import ActionResultEvents from "../../constants/events/ActionResultEvents";
import SessionStore from "../../stores/SessionStore";

export default class SecureRequestExecuter {

    static executeGETRequest(route, requestParams, dataFromAction, responseHandler) {
        const session = SessionStore.getState().session;
        SecureRequestExecuter.sendGET(route, requestParams, session)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }

    static executePOSTRequest(route, requestParams, requestBody, dataFromAction, responseHandler) {
        const session = SessionStore.getState().session;
        SecureRequestExecuter.sendPOST(route, requestParams, session, requestBody)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }

    static executePUTRequest(route, requestParams, requestBody, dataFromAction, responseHandler) {
        const session = SessionStore.getState().session;
        SecureRequestExecuter.sendPUT(route, requestParams, session, requestBody)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }

    static executeDELETERequest(route, requestParams, requestBody, dataFromAction, responseHandler) {
        const session = SessionStore.getState().session;
        SecureRequestExecuter.sendDELETE(route, requestParams, session, requestBody)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) => {
                    console.log("BOOM2");
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()})
                });
    }

    static sendGET(route, params, session) {
        return HTTPRequestExecuter.makeBodilessRequest(
            "GET",
            API_URL + route,
            params,
            {
                'SESSION': session,
            });
    }

    static sendPOST(route, params, session, body) {
        return HTTPRequestExecuter.makeRequest(
            "POST",
            API_URL + route,
            params,
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SESSION': session,
            },
            body);
    }

    static sendPUT(route, params, session, body) {
        return HTTPRequestExecuter.makeRequest(
            "PUT",
            API_URL + route,
            params,
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SESSION': session,
            },
            body);
    }

    static sendDELETE(route, params, session, body) {
        return HTTPRequestExecuter.makeRequest(
            "DELETE",
            API_URL + route,
            params,
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SESSION': session,
            },
            body);
    }
}